module.exports = __webpack_public_path__ + "static/media/mastercard.45a98282.svg";